
import {CustomerList} from '../services/components/customerlist.js'

function getState(customerListState){
    return{
            type:'CUSTOMERLIST_STATE',
            customerListState
    }
}

 export const getCustomerListAction = () => dispatch =>{
    let customerListState = [];
    CustomerList((data, msg) => {

        if (msg === "success") {

            customerListState = {
                status: 200,
                 body: data
            }
        }

        else if (msg === "Failure"){    
            customerListState = {
                status: 401,
                body: "no data"

            }
        }
        else {

            customerListState = {
                status: 204,
                body: data

            }
        }
        dispatch(getState(customerListState))
    }, )

 }


// WEBPACK FOOTER //
// ./src/actions/getcustomerlist.js